import React, { useState } from 'react';
import { getMessage } from '@tcc/i18n';
import styles from './css/SprayAssistInfo.css';
import SprayAssistIcon from '../../images/spray-assist/spray.svg';
import ToolTipIcon from '../../images/spray-assist/tooltip.svg';
import SprayAssistTooltip from './SprayAssistTooltip';

function SprayAssistInfo() {

  const [openTooltip, setOpenTooltip] = useState(false);

  return (
    <div>
      <div className={styles.sprayAssistTooltip}>
        <SprayAssistIcon data-test-id="spray-icon" className={styles.sprayAssistTooltipIcon} />
        <div className={styles.sprayAssistTooltipLabel}>{getMessage('forecast.sprayAssist.tooltip')}</div>
        <a>
          {openTooltip && (
            <SprayAssistTooltip />
          )}
          <ToolTipIcon data-test-id="tooltip-icon" className={styles.sprayAssistTooltipIcon}
            onMouseLeave={() => setOpenTooltip(false)}
            onMouseOver={() => setOpenTooltip(true)}
            onBlur={() => setOpenTooltip(false)}
            onFocus={() => setOpenTooltip(true)}
          />
        </a>
      </div>
    </div>
  );
}

export default SprayAssistInfo;
